"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiCalendar {
    static getCalendarStream(token) {
        let url = `/calendar`;
        return Client_1.default.httpGet(url, token);
    }
    static updateCalendarStream(token, body) {
        let url = `/calendar`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getCalendarConfigurations(token) {
        let url = `/calendar/configuration`;
        return Client_1.default.httpGet(url, token);
    }
    static updateCalendarConfigurations(token, body) {
        let url = `/calendar/configuration`;
        return Client_1.default.httpPost(url, token, body);
    }
}
exports.default = ApiCalendar;
;
